module.exports = __webpack_public_path__ + "static/media/parts.2.222bd60a.png";